import { render, staticRenderFns } from "./BDProductPasteModal.vue?vue&type=template&id=c6c79674&scoped=true&"
import script from "./BDProductPasteModal.vue?vue&type=script&lang=js&"
export * from "./BDProductPasteModal.vue?vue&type=script&lang=js&"
import style0 from "./BDProductPasteModal.vue?vue&type=style&index=0&id=c6c79674&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c79674",
  null
  
)

export default component.exports